<template>
  <el-dialog v-loading="isLoading" title="修改密碼" append-to-body :visible.sync="mIsShow">
    <el-form :model="form">
      <el-form-item label="舊密碼">
        <el-input v-model="form.Old" autocomplete="off" type="password"></el-input>
      </el-form-item>
      <el-form-item label="新密碼">
        <el-input v-model="form.New" autocomplete="off" type="password"></el-input>
      </el-form-item>
      <el-form-item label="確認新密碼">
        <el-input v-model="form.confirm" autocomplete="off" type="password"></el-input>
      </el-form-item>
    </el-form>
    <div slot="footer" class="dialog-footer">
      <el-button @click="close">取消</el-button>
      <el-button type="primary" @click="submit">確定</el-button>
    </div>
  </el-dialog>
</template>

<script>
export default {
  props: {
    isShow: {
      type: Boolean,
      required: true
    }
  },
  data () {
    return {
      form: {
        Old: '',
        New: ''
      },
      mIsShow: false,
      isLoading: false
    }
  },
  methods: {
    close () {
      this.$emit('close')
    },
    submit () {
      if (!this.validateInput()) { return }
      this.$services.administrator.updatePassword(this, this.form).then((res) => {
        let ok = res && res.data && res.data.status === 'ok'
        if (ok) this.onOK()
      }).catch(this.$handleServiceError)
    },
    onOK () {
      this.$message({
        message: `修改成功`,
        type: 'success'
      })
      this.form = {}
      this.close()
    },
    validateInput () {
      var errMsg = null
      if (!this.form.Old) {
        errMsg = '請輸入舊密碼'
      } else if (!this.form.New) {
        errMsg = '請輸入新密碼'
      } else if (this.form.New !== this.form.confirm) {
        errMsg = '兩次輸入密碼不同'
      }

      if (errMsg) {
        this.$alert(errMsg, '錯誤', {
          confirmButtonText: '確認',
          type: 'error'
        })
      }
      return errMsg === null
    }
  },
  created () {
    this.mIsShow = this.isShow
  },
  watch: {
    isShow () {
      this.mIsShow = this.isShow
    },
    mIsShow () {
      if (!this.mIsShow) this.close()
    }
  }
}
</script>
